module.exports = __webpack_public_path__ + "static/img/MATTHEW-OWEN.9cb109d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MATTHEW-OWEN.jpg
// module id = RnKU
// module chunks = 0